import { useRouter } from "next/router";
import LazyImage from "@/my_components/Common/LazyImage";
import Link from "next/link";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

import { logoutUser } from "@/services/authService";
import { image_url } from "@/helper/Utilities";
import { ROUTE } from "@/route/app_routes";
import { ADMIN_NAV_ITEMS, STUDENT_NAV_ITEMS } from "@/my_data/dashboard/navConfig";
import { useProfile } from "@/context/ProfileContext";

const User = ({ user }) => {
  const router = useRouter();
  const { t } = useTranslation();
  // ProfileContext fetches /api/auth/me once per app session, and this logout button navigates
  // client-side (router.push, no full reload) -- without this, the navbar would keep showing
  // this user's name/avatar after logout until the next full page load. See LoginForm.js for the
  // equivalent fix on the way in.
  const { refreshProfile } = useProfile();

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await logoutUser();
    } catch (error) {
      // Fall through and redirect regardless -- the httpOnly cookie is cleared server-side
      // either way, so there's no world where staying on the page is the right outcome.
    }
    await refreshProfile();
    toast.success(t("nav.loggedOutToast"));
    router.push(ROUTE.login);
  };

  const isAdmin = user?.USER_ROLE === "admin";

  // Same list the role-appropriate dashboard sidebar renders (my_data/dashboard/navConfig.js)
  // -- so this dropdown always contains every destination the sidebar does, from any page,
  // not a hand-picked subset that can quietly drift out of sync with it over time.
  const menuItems = isAdmin ? ADMIN_NAV_ITEMS : STUDENT_NAV_ITEMS;

  return (
    <div className="rbt-user-menu-list-wrapper">
      <div className="inner">

        <div className="rbt-admin-profile">
          <div className="admin-thumbnail">
            <LazyImage src={user?.DP || image_url("/app_images/dashboard/avatar.webp")} width={52} height={52} alt={t("nav.userAvatarAlt")} />
          </div>
          <div className="admin-info">
            <span className="name">{`${user.FIRSTNAME} ${user.LASTNAME}`.trim()}</span>
            <Link className="rbt-btn-link color-primary" href={ROUTE.dashboardProfile}>
              {t("nav.viewProfile")}
            </Link>
          </div>
        </div>

        <ul className="user-list-wrapper">
          {menuItems.map((item) => (
            <li key={item.link}>
              <Link href={item.link}>
                <span className="rbt-user-menu-icon"><i className={item.icon}></i></span>
                <span>{item.textKey ? t(item.textKey, item.text) : item.text}</span>
              </Link>
            </li>
          ))}
        </ul>

        <hr className="mt--10 mb--10" />

        <ul className="user-list-wrapper">
          <li>
            <Link href={isAdmin ? ROUTE.adminSettings : ROUTE.dashboardSettings}>
              <span className="rbt-user-menu-icon"><i className="feather-settings"></i></span>
              <span>{t("nav.settings")}</span>
            </Link>
          </li>

          <li>
            <a href="#" className="is-logout" onClick={handleLogout}>
              <span className="rbt-user-menu-icon"><i className="feather-log-out"></i></span>
              <span>{t("nav.logout")}</span>
            </a>
          </li>
        </ul>

      </div>
    </div>
  );
};

export default User;
